module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-0-1.13c7fb4f.jpg";